<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-if="curso">{{ curso.NOME }}</dd>
  </div>
</template>

<script>
import AlunoService from "../../../../domain/corpore/AlunoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "view-c-protocolo-todos-curso",
  props: {
    label: String,
    value: String,
    login: String
  },
  asyncComputed: {
    curso() {
      const alunoService = new AlunoService(this.$http);
      if (this.login) {
        return alunoService
          .getAllCursosAlunoByRa(this.login)
          .then(result => result.find(curso => this.value == curso.CODCURSO))
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/TodosCurso.vue